import React from "react";
import { Award } from "lucide-react";
import { Card } from "@/components/ui/card";

interface Achievement {
  id: string;
  title: string;
  description?: string;
}

interface AchievementsListProps {
  achievements: Achievement[];
}

export const AchievementsList: React.FC<AchievementsListProps> = ({ achievements }) => {
  if (!achievements || achievements.length === 0) return null;
  
  return (
    <div className="space-y-2">
      {achievements.map(achievement => (
        <Card 
          key={achievement.id} 
          className="bg-[#1E293B] border-[#2D3748] p-3 flex items-start gap-3 text-left"
        >
          <Award className="h-5 w-5 text-yellow-400 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-white">{achievement.title}</h4>
            {achievement.description && (
              <p className="text-xs text-gray-400 mt-1">{achievement.description}</p>
            )}
          </div>
        </Card>
      ))}
    </div>
  );
};
